"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericCounterKeyToJSON = exports.GenericCounterKeyFromJSONTyped = exports.GenericCounterKeyFromJSON = exports.GenericCounterKey = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GenericCounterKey;
(function (GenericCounterKey) {
    GenericCounterKey["PLACESAPICALLS"] = "PLACES_API_CALLS";
    GenericCounterKey["AUTOCOMPLETEAPICALLS"] = "AUTOCOMPLETE_API_CALLS";
})(GenericCounterKey = exports.GenericCounterKey || (exports.GenericCounterKey = {}));
function GenericCounterKeyFromJSON(json) {
    return GenericCounterKeyFromJSONTyped(json, false);
}
exports.GenericCounterKeyFromJSON = GenericCounterKeyFromJSON;
function GenericCounterKeyFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GenericCounterKeyFromJSONTyped = GenericCounterKeyFromJSONTyped;
function GenericCounterKeyToJSON(value) {
    return value;
}
exports.GenericCounterKeyToJSON = GenericCounterKeyToJSON;
